import { makeStyles } from '@material-ui/core/styles';

/** Styles partagés entre les 3 vues webinaires */
export const useWebinaireListStyles = makeStyles((theme) => ({
  page: {
    width: '100%',
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 0, 3),
    },
  },
  pageWithBg: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  card: {
    padding: theme.spacing(2.5),
    width: '100%',
    boxSizing: 'border-box',
  },
  cardHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    width: '100%',
  },
  meta: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    fontWeight: 600,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    alignSelf: 'flex-end',
    marginTop: theme.spacing(2),
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 220,
    textAlign: 'center',
    padding: theme.spacing(4, 2),
    maxWidth: 420,
    margin: '0 auto',
  },
  emptyTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  emptyHint: {
    color: theme.palette.text.secondary,
  },
}));

/** Durée stockée en minutes (API) */
export function formatDurationMinutes(minutes) {
  if (minutes == null || Number.isNaN(Number(minutes))) return '';
  const m = Number(minutes);
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (h === 0) return `${rest} min`;
  if (rest === 0) return `${h} h`;
  return `${h} h ${rest} min`;
}
